import { render } from "./DirectMailBuilder.vue?vue&type=template&id=78619f00&scoped=true"
import script from "./DirectMailBuilder.vue?vue&type=script&lang=js"
export * from "./DirectMailBuilder.vue?vue&type=script&lang=js"

import "./DirectMailBuilder.vue?vue&type=style&index=0&id=78619f00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78619f00"]])

export default __exports__